import { render, staticRenderFns } from "./TagsOverview.vue?vue&type=template&id=26afa830&scoped=true&"
import script from "./TagsOverview.vue?vue&type=script&lang=ts&"
export * from "./TagsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./TagsOverview.vue?vue&type=style&index=0&id=26afa830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afa830",
  null
  
)

export default component.exports